import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=00b5a04c&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=00b5a04c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b5a04c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00b5a04c')) {
      api.createRecord('00b5a04c', component.options)
    } else {
      api.reload('00b5a04c', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=00b5a04c&scoped=true&", function () {
      api.rerender('00b5a04c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/performanceCalculation/views/result_statement/annual_network_performance_report/form/detail.vue"
export default component.exports